import {Component, OnInit, Input, OnChanges, SimpleChanges} from '@angular/core';
import {HelperService} from '../../services/helper.service';
import {ApiService} from '../../../api/api.service';
import {Router} from '@angular/router';

@Component({
  selector: 'knowledge-base',
  templateUrl: './knowledge-base.component.html',
  styleUrls: ['./knowledge-base.component.scss']
})

export class KnowledgeBaseComponent implements OnInit, OnChanges {
  @Input() setSize: any;
  @Input() change: any;
  @Input() items: any;
  @Input() defaultItems: any;
  @Input() preview: boolean;
  @Input() border: boolean = true;

  widget: any;
  waiting = true;
  data: any;
  whiteBackground: boolean = false;

  constructor(private _helper: HelperService,
              private _api: ApiService,
              private _router: Router) {}

  ngOnInit() {
    if(!this.preview){
      this.prepareKnowledgeBaseData();
    }else{
      this.prepareWidgetData()
      this.waiting = false;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.prepareWidgetData();
  }

  prepareWidgetData(){
    if(this.items) {
      this.widget = {
        sizeClass: null !== this.items.size && this.items.size !== undefined ? this.items.size : this.defaultItems.defaultSize,
        backgroundColor: null !== this.items.backgroundColor && this.items.backgroundColor !== undefined ? this.items.backgroundColor : this.defaultItems.defaultBackgroundColor,
        elementsColor: null !== this.items.elementsColor && this.items.elementsColor !== undefined ? this.items.elementsColor : this.defaultItems.defaultElementsColor,
        data: this.preview ? this.getExampleData() : this.data
      };
      this.whiteBackground = this.widget.backgroundColor.toLowerCase() === 'ffffff';
    }
  }

  hexToRGB(hex, alpha) {
    var r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);

    if (alpha) {
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    } else {
      return 'rgb(' + r + ', ' + g + ', ' + b + ')';
    }
  }

  prepareKnowledgeBaseData(){
    this._api.Dashboard.getKnowledgeBaseData().subscribe((res) => {
      this.data = res;
      this.waiting = false;
      this.prepareWidgetData()
    });
  }

  getExampleData(){
    return {
      articles: [
        {
          'name': 'Logo firmowe  FIRMY / Print + Outdoor',
          'categories': [
            {'name': 'Nowy brandbook firmy'},
            {'name': 'Ogólne'},
            {'name': 'Dla prasy'}
            ]
        },
        {
          'name': 'Zasady dofinansowania pobytu weekendowego',
          'categories': [
            {'name': 'Brandbook firmy'},
            {'name': 'Ogólne'},
            {'name': 'Onboarding'}
          ]
        },
        {
          'name': 'Logo firmowe  FIRMY / Print + Outdoor',
          'categories': [
            {'name': 'Dla prasy'},
            {'name': 'Nowy brandbook firmy'},
            ]
        },
        ]
    }
  }

  goTo(id){
    if(!this.preview){
      this._router.navigateByUrl('/app/library/knowledge-base/article/player/' + id);
    }
  }
}